import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import { elevations } from '../styles/elevations.js';
import shippoTheme from '../styles/shippoTheme.js';

const variantContainedOverride = {
    '&.MuiButton-containedPrimary': {
        boxShadow: elevations[1],
        color: colors.white,
        '&:hover': {
            boxShadow: elevations[2],
        },
        '&.Mui-disabled': {
            backgroundColor: colors.web.primary.disabled,
            boxShadow: elevations[0],
            color: colors.white,
        },
    },
    '&.MuiButton-containedSecondary': {
        color: colors.secondary,
        outline: `${colors.secondary} solid 1px`,
        backgroundColor: colors.white,
        boxShadow: elevations[0],
        boxSizing: 'border-box',
        '&:focus': {
            outline: `${colors.web.hover} 4px solid`,
        },
        '&:hover': {
            boxShadow: elevations[1],
            backgroundColor: colors.web.secondary.hover,
        },
        '&.Mui-disabled': {
            outline: `${colors.web.secondary.disabled} solid 1px`,
            color: colors.web.secondary.disabled,
            backgroundColor: colors.white,
            boxShadow: elevations[0],
        },
    },
    '&.MuiButton-containedError': {
        color: colors.white,
        boxShadow: elevations[1],
        '&:hover': {
            boxShadow: elevations[2],
        },
        '&.Mui-disabled': {
            backgroundColor: colors.web.error.disabled,
            boxShadow: elevations[0],
            color: colors.white,
        },
    },
};
const variantTextOverride = {
    '&.MuiButton-textPrimary': {
        color: colors.accent.foreground.success,
        boxShadow: elevations[0],
        backgroundColor: colors.transparent,
        '&:hover': {
            boxShadow: elevations[1],
            backgroundColor: colors.web.hover,
        },
        '&.Mui-disabled': {
            color: colors.web.primary.disabled,
        },
    },
    '&.MuiButton-textSecondary': {
        color: colors.secondary,
        boxShadow: elevations[0],
        '&:hover': {
            backgroundColor: colors.secondaryHover,
            boxShadow: elevations[1],
        },
        '&.Mui-disabled': {
            color: colors.web.secondary.disabled,
        },
    },
    '&.MuiButton-textError': {
        color: colors.accent.foreground.error,
        boxShadow: elevations[0],
        '&:hover': {
            boxShadow: elevations[1],
            backgroundColor: colors.accent.background.error,
        },
        '&.Mui-disabled': {
            color: colors.web.error.disabled,
        },
    },
};
const buttonBySizeOverride = {
    '&.MuiButton-sizeLarge': {
        padding: shippoTheme.spacing(2),
    },
    '&.MuiButton-sizeMedium': {
        padding: `${shippoTheme.spacing(1.5)} ${shippoTheme.spacing(2)}`,
    },
    '&.MuiButton-sizeSmall': {
        padding: shippoTheme.spacing(1),
    },
};
const buttonWithIconOverride = {
    // Icon with Text
    '&:has(span.MuiButton-startIcon), :has(span.MuiButton-endIcon)': {
        gap: shippoTheme.spacing(2),
    },
    '& span.MuiButton-startIcon, span.MuiButton-endIcon': {
        margin: 0,
    },
};
const buttonThemeInput = {
    palette: {
        primary: {
            main: colors.accent.foreground.success,
            dark: colors.primaryButtonHover,
        },
        secondary: {
            main: colors.secondary,
            dark: colors.secondary,
        },
        error: {
            main: colors.accent.foreground.error,
            dark: colors.specialUse.hover,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign(Object.assign({ color: colors.secondary, textTransform: 'none', fontWeight: 500, fontSize: '1rem', lineHeight: '1.5rem', fontStyle: 'normal', borderRadius: '8px', whiteSpace: 'nowrap', minWidth: 'auto', justifyContent: 'center', '&:focus': {
                        outline: `${colors.web.hover} 4px solid`,
                    } }, buttonWithIconOverride), buttonBySizeOverride), variantContainedOverride), variantTextOverride),
            },
        },
    },
};
var buttonTheme = createTheme(shippoTheme, buttonThemeInput);

export { buttonThemeInput, buttonTheme as default };
//# sourceMappingURL=Button.theme.js.map
